import { CourrierRecipientEntry, CourrierStatus, CourrierType } from '../models/courrier.model';

const STATUS_ACCENT_MAP: Record<CourrierStatus, 'blue' | 'green' | 'pink' | 'orange' | 'teal' | 'grey'> = {
  sent: 'blue',
  open: 'green',
  error: 'pink',
  transmitted: 'orange',
  signed: 'teal',
  not_opened: 'pink',
  recipient_unknown: 'pink',
  delivered_in_person: 'grey',
};

export function getStatusAccent(status: string): 'blue' | 'green' | 'pink' | 'orange' | 'teal' | 'grey' {
  return STATUS_ACCENT_MAP[status as CourrierStatus] ?? 'blue';
}

export function getTypeAccent(type: string): 'grey' | 'purple' {
  return (type as CourrierType) === 'tracked' ? 'purple' : 'grey';
}

/** Returns `"Firstname Lastname"` for a single entry. */
export function entryFullName(entry: CourrierRecipientEntry): string {
  return `${entry.firstname} ${entry.lastname}`;
}
